﻿import { Dispatch } from 'redux';
import { DateGroupType } from '../../model/active/dateGroupType';
import { PassiveParameterTypeEnum } from '../../model/passive/enum/passiveParameterTypeEnum';
import { passiveParametersService } from '../../services/PassiveParameterService/passiveParametersService';
import {
  CLEAR_SELECTED_DAILY_PARAMETER,
  FETCH_AVERAGE_WALKING_SPEED,
  FETCH_DAILY_PARAMETER_DATA,
  FETCH_DAILY_PARAMETER_DATA_FAILURE,
  FETCH_DAILY_PARAMETER_DATA_SUCCESS,
  FETCH_DAILY_PARAMETER_DATES,
  FETCH_DAILY_PARAMETER_DATES_FAILURE,
  FETCH_DAILY_PARAMETER_DATES_SUCCESS,
  FETCH_PASSIVE_PARAMETER_DATA,
} from '../constants/dailyParameterConstants';

export function fetchDailyParameterDates() {
  return {
    type: FETCH_DAILY_PARAMETER_DATES,
  };
}

export function fetchDailyParameterDatesSuccess(data: any) {
  return {
    type: FETCH_DAILY_PARAMETER_DATES_SUCCESS,
    payload: data,
  };
}

export function fetchDailyParameterDatesError(error: string) {
  return {
    type: FETCH_DAILY_PARAMETER_DATES_FAILURE,
    payload: error,
  };
}

export function getDailyParameterDates(
  patientId: string,
  startDate: string,
  endDate: string,
  type?: PassiveParameterTypeEnum
) {
  return async function action(dispatch: Dispatch<any>) {
    dispatch(fetchDailyParameterDates());
    return await passiveParametersService
      .getDailyParameterDatesByRange(patientId, startDate, endDate, type)
      .then(
        (response: any) => dispatch(fetchDailyParameterDatesSuccess(response))
        //error => dispatch(someerror('woody', buzz, error))
      );
  };
}

export function fetchDailyParameterData() {
  return {
    type: FETCH_DAILY_PARAMETER_DATA,
  };
}

export function fetchDailyParameterDataSuccess(data: any) {
  return {
    type: FETCH_DAILY_PARAMETER_DATA_SUCCESS,
    payload: data,
  };
}

export function fetchDailyParameterDataError(error: string) {
  return {
    type: FETCH_DAILY_PARAMETER_DATA_FAILURE,
    payload: error,
  };
}

export function getDailyParameterData(accountGuid: string, date: Date) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(fetchDailyParameterData());
    return passiveParametersService
      .getDailyParametersByDate(accountGuid, date)
      .then(
        (response: any) => dispatch(fetchDailyParameterDataSuccess(response))
        //error => dispatch(someerror('woody', buzz, error))
      );
  };
}

export function getPassiveParameterData(
  accountGuid: string,
  dateStart: Date,
  dateEnd: Date,
  dateType: DateGroupType,
  parameterType: PassiveParameterTypeEnum
) {
  return function action(dispatch: Dispatch<any>) {
    return passiveParametersService
      .getPassiveParameterDataByType(
        accountGuid,
        dateStart,
        dateEnd,
        dateType,
        parameterType
      )
      .then((response: any) => {
        dispatch({
          type: FETCH_PASSIVE_PARAMETER_DATA,
          payload: {
            data: response,
            parameterType: parameterType,
          },
        });
      });
  };
}

// Keep for backward compatibility
export function getAverageWalkingSpeedData(
  accountGuid: string,
  dateStart: Date,
  dateEnd: Date,
  dateType: DateGroupType
) {
  return function action(dispatch: Dispatch<any>) {
    return passiveParametersService
      .getAverageWalkingSpeed(accountGuid, dateStart, dateEnd, dateType)
      .then((response: any) => {
        dispatch({
          type: FETCH_AVERAGE_WALKING_SPEED,
          payload: response,
        });
      });
  };
}

export function clearSelectedDailyParameter() {
  return {
    type: CLEAR_SELECTED_DAILY_PARAMETER,
  };
}
